import { useState } from 'react';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { NOTICE_CATEGORIES, NOTICE_TYPES } from '../../common/constants';
import { YellowChipIcon, RedChipIcon, GrayChipIcon, BrownChipIcon } from './NoticeTypeIcons';
import RegulationImageDialog from '../RegulationImageDialog';
import AttentionImageDialog from '../AttentionImageDialog';

import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Grid from '@mui/material/Grid';

// 通告・通告テンプレートの作成で使用する「通告の種類」
const NoticeTypeButtons = (props) => {
  const { index, notice } = props;
  const { noticeCategoryCode, noticeTypeCode } = notice;
  const { typography } = useTheme();
  const styles = {
    help: { ...typography.caption12bold, display: 'flex', alignItems: 'center' },
    chip: { ...typography.label14, height: '44px', padding: '0px 20px', borderRadius: '100px' },
    headlineText: { ...typography.caption13bold, color: 'secondary.main' },
  };
  const [openRegulationImageDialog, setOpenRegulationImageDialog] = useState(false);
  const [openAttentionImageDialog, setOpenAttentionImageDialog] = useState(false);

  const handleClick = (category, type) => {
    props.handleChange(
      {
        noticeCategoryCode: category,
        noticeTypeCode: type,
      },
      index,
    );
  };

  return (
    <>
      <Stack marginBottom='36px'>
        <Stack direction='row' marginBottom='8px' spacing={1}>
          <FormHelperText sx={styles.headlineText}>運転規制/解除（受領ボタンのタップが必要）</FormHelperText>
          <Link
            color='primary.main' sx={styles.help} underline="hover"
            onClick={() => setOpenRegulationImageDialog(true)}
          >
            <HelpOutlineIcon fontSize="small" />運転規制/解除のイメージ
          </Link>
        </Stack>
        <Grid container marginBottom='20px' spacing={1}>
          <Grid item>
            <Chip
              avatar={YellowChipIcon}
              label={NOTICE_TYPES.THIRTY_FIVE_LIMIT.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.REGULATION.value &&
                  noticeTypeCode === NOTICE_TYPES.THIRTY_FIVE_LIMIT.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.REGULATION.value, NOTICE_TYPES.THIRTY_FIVE_LIMIT.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={YellowChipIcon}
              label={NOTICE_TYPES.TWENTY_FIVE_LIMIT.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.REGULATION.value &&
                  noticeTypeCode === NOTICE_TYPES.TWENTY_FIVE_LIMIT.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.REGULATION.value, NOTICE_TYPES.TWENTY_FIVE_LIMIT.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={RedChipIcon}
              label={NOTICE_TYPES.SUSPENSION.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.REGULATION.value &&
                  noticeTypeCode === NOTICE_TYPES.SUSPENSION.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.REGULATION.value, NOTICE_TYPES.SUSPENSION.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={GrayChipIcon}
              label={NOTICE_TYPES.LIMIT_CANCEL.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.REGULATION.value &&
                  noticeTypeCode === NOTICE_TYPES.LIMIT_CANCEL.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.REGULATION.value, NOTICE_TYPES.LIMIT_CANCEL.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={GrayChipIcon}
              label={NOTICE_TYPES.SUSPENSION_CANCEL.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.REGULATION.value &&
                  noticeTypeCode === NOTICE_TYPES.SUSPENSION_CANCEL.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.REGULATION.value, NOTICE_TYPES.SUSPENSION_CANCEL.value);
              }}
            />
          </Grid>
        </Grid>
        <Stack direction='row' marginBottom='8px' spacing={1}>
          <FormHelperText sx={styles.headlineText}>注意喚起情報</FormHelperText>
          <Link
            color='primary.main' sx={styles.help} underline="hover"
            onClick={() => setOpenAttentionImageDialog(true)}
          >
            <HelpOutlineIcon fontSize="small" />注意喚起情報のイメージ
          </Link>
        </Stack>
        <Grid container marginBottom='20px' spacing={1}>
          <Grid item>
            <Chip
              avatar={YellowChipIcon}
              label={NOTICE_TYPES.THIRTY_FIVE_LIMIT.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.ATTENTION.value &&
                  noticeTypeCode === NOTICE_TYPES.THIRTY_FIVE_LIMIT.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.ATTENTION.value, NOTICE_TYPES.THIRTY_FIVE_LIMIT.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={YellowChipIcon}
              label={NOTICE_TYPES.TWENTY_FIVE_LIMIT.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.ATTENTION.value &&
                  noticeTypeCode === NOTICE_TYPES.TWENTY_FIVE_LIMIT.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.ATTENTION.value, NOTICE_TYPES.TWENTY_FIVE_LIMIT.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={RedChipIcon}
              label={NOTICE_TYPES.SUSPENSION.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.ATTENTION.value &&
                  noticeTypeCode === NOTICE_TYPES.SUSPENSION.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.ATTENTION.value, NOTICE_TYPES.SUSPENSION.value);
              }}
            />
          </Grid>
          <Grid item>
            <Chip
              avatar={BrownChipIcon}
              label={NOTICE_TYPES.SLOWDOWN.label}
              sx={styles.chip}
              variant={
                noticeCategoryCode === NOTICE_CATEGORIES.ATTENTION.value &&
                  noticeTypeCode === NOTICE_TYPES.SLOWDOWN.value ?
                  'selected' : 'filled'
              }
              onClick={() => {
                handleClick(NOTICE_CATEGORIES.ATTENTION.value, NOTICE_TYPES.SLOWDOWN.value);
              }}
            />
          </Grid>
        </Grid>
      </Stack>
      {/* 運転規制/解除 選択時のDTAC側表示イメージ */}
      <RegulationImageDialog
        open={openRegulationImageDialog}
        setOpen={setOpenRegulationImageDialog}
      />
      {/* 注意喚起情報/解除 選択時のDTAC側表示イメージ */}
      <AttentionImageDialog
        open={openAttentionImageDialog}
        setOpen={setOpenAttentionImageDialog}
      />
    </>
  );
};

export default NoticeTypeButtons;

NoticeTypeButtons.propTypes = {
  index: PropTypes.number,
  notice: PropTypes.object,
  handleChange: PropTypes.func,
};
